import {allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode} from "../../components/settings/utils";

enum BACKEND_ERROR_TYPE {
    VALIDATION = "Validation",
    FLIGHT_CALCULATION = "Flight calculation",
    HOTEL_CALCULATION = "Hotel calculation",
    FUSIONAUTH = "FusionAuth",
    ROLEMANAGEMENT = "RoleManagement",
    REQUEST = "Request",
}

export enum GENERAL_BACKEND_RESPONSE {
    success = 'SUCCESS',
    failure = 'FAILED'
}

export interface ContactPersonsProps {
    firstContactFirstName: string,
    firstContactLastName: string,
    firstContactEmail?: string | null,
    secondContactFirstName?: string | null,
    secondContactLastName?: string | null,
    secondContactEmail?: string | null,
}

export interface GeneralBackendResponse {
    status: GENERAL_BACKEND_RESPONSE,
    errorCode?: number,
    type: BACKEND_ERROR_TYPE,
    message: string,
    problematicValues?: string[],
    response: any | null
}

export enum CALCULATED_EMISSIONS_RESPONSE_STATUS_PARTIAL {
    success = 'SUCCESS',
    failed = 'FAILED'
}

export enum CALCULATE_EMISSIONS_RESPONSE_STATUS_TOTAL {
    success = 'SUCCESS',
    success_with_errors = 'SUCCESS_WITH_ERRORS',
    failed = 'FAILED'
}

export const STATUS_ORDER: { [key in CALCULATE_EMISSIONS_RESPONSE_STATUS_TOTAL]: number } = {
    [CALCULATE_EMISSIONS_RESPONSE_STATUS_TOTAL.success]: 1,
    [CALCULATE_EMISSIONS_RESPONSE_STATUS_TOTAL.success_with_errors]: 2,
    [CALCULATE_EMISSIONS_RESPONSE_STATUS_TOTAL.failed]: 3
};

export enum CALCULATION_TYPE {
    flight = 'flight',
    hotel = 'hotel',
    car = 'car',
    bus = 'bus'
}

export interface CompanyAgencyAddress {
    street: string,
    houseNumber: string,
    zipCode: string,
    city: string,
    country: string,
    additionalInformation: string,
    phoneNumber: string,
    internationalPhonePrefix: keyof typeof allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode
}

export enum NON_CALCULATION_ERROR_TYPES {
    USER_MANAGEMENT,
    FUSION_AUTH
}

export const relevantErrorCodes = {
    // Role Management
    501: 'CODE_501',
    504: 'CODE_504',
    506: 'CODE_506',
    508: 'CODE_508',
    509: 'CODE_509',
    514: 'CODE_514',
    518: 'CODE_518',

    // flight
    601: 'CODE_601',
    602: 'CODE_602',
    603: 'CODE_603',
    604: 'CODE_604',
    605: 'CODE_605',
    606: 'CODE_606',
    607: 'CODE_607',
    608: 'CODE_608',
    609: 'CODE_609',
    610: 'CODE_610',
    611: 'CODE_611',
    612: 'CODE_612',
    613: 'CODE_613',
    614: 'CODE_614',
    615: 'CODE_615',
    616: 'CODE_616',
    617: 'CODE_617',
    618: 'CODE_618',
    619: 'CODE_619',
    620: 'CODE_620',
    621: 'CODE_621',
    622: 'CODE_622',
    623: 'CODE_623',
    624: 'CODE_624',
    625: 'CODE_625',
    627: 'CODE_627',
    628: 'CODE_628',

    // Hotel
    701: 'CODE_701',
    702: 'CODE_702',
    703: 'CODE_703',
    704: 'CODE_704',
    705: 'CODE_705',

    //Car-Bus
    751: 'CODE_751',
    752: 'CODE_752',
    753: 'CODE_753',
    754: 'CODE_754',
    755: 'CODE_755',
    757: 'CODE_757',
    758: 'CODE_758',
    759: 'CODE_759',
    760: 'CODE_760',
    761: 'CODE_761',
    762: 'CODE_762',
    763: 'CODE_763',
    764: 'CODE_764',
    765: 'CODE_765',

    // Request
    802: 'CODE_802',
    817: 'CODE_817',
    830: 'CODE_830',

    // Fusion Auth
    906: 'CODE_906',
    907: 'CODE_907',
    910: 'CODE_910',
    912: 'CODE_912',
    917: 'CODE_917',
}

export interface NonCalculationResponseError {
    status: number,
    data: {
        errorCode: keyof typeof relevantErrorCodes,
        message: string
        problematicValues: string[],
        type: keyof typeof NON_CALCULATION_ERROR_TYPES,
    }
}

/**
 * General error object from Backend
 */
export interface BackendError {
    errorCode: string,
    message: string
    problematicValues: string[],
    code: keyof typeof relevantErrorCodes
}

export enum ScrollDirection {
    forward = "forward",
    backward = "backward"
}

export interface UserCookie {
    applicationId: string;
    email: string;
    email_verified: boolean;
    family_name: string;
    given_name: string;
    roles: string[];
    scope: string;
    sid: string;
    sub: string;
    tid: string;
}